import './includes/popups.js';

let form = $('#сform');

if(form) {
    form.submit(function(e) {
        e.preventDefault();
        $.ajax({
            type: "POST",
            url: api_settings.ajax_url,
            data: form.serialize(),
            processData: false,
            success: function (result) {
                form[0].reset()
                alert("Message sent!");
            },
            error: function () {
                alert("error");
            }
        })
    });
}

$('.lang-switcher, .lang-switcher-mob').click(function() {
    $(this).toggleClass('open');
});
